// Page events
export const HOME_PAGE_VIEW = 'Home Page Viewed';
export const NEWS_PAGE_VIEW = 'News Page Viewed';
export const LEAGUE_PAGE_VIEW = 'League Page Viewed';
export const ARTICLE_PAGE_VIEW = 'Article Page Viewed';

// User events
export const NAV_LINK_CLICKED = 'Navigation Link Clicked';
export const ARTICLE_LINK_CLICKED = 'Article Link Clicked';
export const HOME_CTA = 'Home Page Hero CTA Clicked';

// Video events
export const PLAY_VIDEO = 'Video Play Successful';
export const PLAY_25_VIDEO = 'Video 25% Played';
export const PLAY_50_VIDEO = 'Video 50% Played';
export const PLAY_75_VIDEO = 'Video 75% Played';
export const COMPLETE_VIDEO = 'Video 100% Played';
